var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import layoutComponentsDictionary from "../layoutComponentsDictionary";
/**
 * List component of Layout rows
 */
export function LayoutRowsList() {
    return (_jsx(_Fragment, { children: _jsxs("span", __assign({ className: "flex flex-row items-center" }, { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-4 h-4" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z" }) })), _jsx("span", __assign({ className: "ml-2" }, { children: "ROWS" }))] })) }));
}
layoutComponentsDictionary.registerLayoutComponent("layout-rows-list", LayoutRowsList);
